


















































































































































































































import Vue from 'vue'
import { Component } from 'vue-property-decorator'
import AbpBase from '../../lib/abpbase'
import VipApi from '@/api/vip/list'
import OrderApi from '@/api/order/list'
import VipTag from '@/api/vip/vipTag/index'
import TagSelect from '@/components/tag-select/index.vue'
@Component({
  components: {
    TagSelect,
  },
})
export default class VipDetails extends AbpBase {
  columns: any[] = [
    {
      title: '订单编号',
      key: 'orderNo',
      align: 'center',
    },
    {
      title: '订单金额',
      slot: 'payAmount',
      align: 'center',
    },
    {
      title: '订单类型',
      slot: 'orderType',
      align: 'center',
    },
    {
      title: '收货人',
      slot: 'shippingAddress',
      align: 'center',
    },
    {
      title: '订单状态',
      key: 'orderFullStatusStr',
      align: 'center',
    },
    {
      title: '下单时间',
      slot: 'creationTime',
      align: 'center',
    },
    {
      title: '备注',
      key: 'remark',
      align: 'center',
    },
    {
      title: '操作',
      slot: 'action',
      align: 'center',
    },
  ]
  tableData: any[] = []
  table: any = {
    currentPage: 1,
    totalCount: 0,
    pageSize: 10,
  }

  columns2: any[] = [
    {
      title: '记录',
      slot: 'amount',
      align: 'center',
    },
    {
      title: '时间',
      slot: 'creationTime',
      align: 'center',
    },
    {
      title: '备注',
      key: 'remark',
      align: 'center',
    },
  ]
  tableData2: any[] = []
  table2: any = {
    currentPage: 1,
    totalCount: 0,
    pageSize: 10,
  }

  columns3: any[] = [
    {
      title: '记录',
      slot: 'amount',
      align: 'center',
    },
    {
      title: '时间',
      slot: 'creationTime',
      align: 'center',
    },
    {
      title: '备注',
      key: 'remark',
      align: 'center',
    },
  ]
  tableData3: any[] = []
  table3: any = {
    currentPage: 1,
    totalCount: 0,
    pageSize: 10,
  }

  columns4: any[] = [
    {
      title: '名称',
      key: 'name',
      align: 'center',
    },
    {
      title: '收藏类型',
      slot: 'type',
      align: 'center',
    },
    {
      title: '收藏时间',
      slot: 'creationTime',
      align: 'center',
    },
  ]
  tableData4: any[] = []
  table4: any = {
    currentPage: 1,
    totalCount: 0,
    pageSize: 10,
  }

  columns5: any[] = [
    {
      title: '关键字',
      key: 'itemKey',
      align: 'center',
    },
    {
      title: '类型',
      slot: 'type',
      align: 'center',
    },
    {
      title: '浏览时间',
      slot: 'creationTime',
      align: 'center',
    },
  ]
  tableData5: any[] = []
  table5: any = {
    currentPage: 1,
    totalCount: 0,
    pageSize: 10,
  }

  columns6: any[] = [
    {
      title: '优惠券名称',
      key: 'couponName',
      align: 'center',
    },
    {
      title: '优惠券编码',
      key: 'code',
      align: 'center',
    },
    {
      title: '状态',
      slot: 'status',
      align: 'center',
    },
    {
      title: '领取时间',
      slot: 'creationTime',
      align: 'center',
    },
  ]
  tableData6: any[] = []
  table6: any = {
    currentPage: 1,
    totalCount: 0,
    pageSize: 10,
  }
  recentTypeList = [
    { title: '浏览商品', value: 0 },
    { title: '添加到购物车', value: 1 },
    { title: '购物车移除商品', value: 2 },
    { title: '购买商品', value: 3 },
    { title: '收藏商品', value: 4 },
    { title: '分享商品', value: 5 },
    { title: '评价商品', value: 6 },
    { title: '浏览文章', value: 7 },
    { title: '收藏文章', value: 8 },
    { title: '分享文章', value: 9 },
    { title: '评论文章', value: 10 },
    { title: '点赞文章', value: 11 },
  ]
  recentType = null

  vipInfos: any = {}
  allTagList: any[] = []
  showTag: boolean = false
  selectedItems: any = []

  // get tagsString() {
  //   let tags = this.vipInfos.tags
  //   return tags ? tags.join('，') : ''
  // }
  get tagList() {
    // let arr = this.vipInfos.tags.forEach(item => {
    //   item.show = true
    // })
    return this.vipInfos.tags
  }

  created() {
    this.getVipInfos()
    this.getTagList()
    this.getOrderList()
    this.getBonusLog()
    this.getBalanceLogs()
    this.getVipFavorite()
    this.getVipRecentLogs()
    this.getVipCoupons()
  }

  couponTypeString(type) {
    let text = type
    switch (type) {
      case 0:
        text = '未使用'
        break
      case 1:
        text = '冻结'
        break
      case 2:
        text = '已使用'
        break
      case 3:
        text = '过期'
        break
      case 4:
        text = '停用'
        break
      case 5:
        text = '待领取'
        break
    }

    return text
  }

  /**
   * 获取会员详情
   */
  getVipInfos() {
    let id = this.$route.query['id']
    if (id) {
      VipApi.getVipInfos(id.toString()).then((res) => {
        this.vipInfos = res.data
      })
    }
  }

  /**
   * 获取指定会员消费列表
   */
  getOrderList() {
    let id = this.$route.query['id']
    if (id) {
      let { table } = this
      OrderApi.getOrderList(table.pageSize, table.currentPage, null, null, null, null, null, null, id.toString()).then(
        (res) => {
          if (res.data) {
            this.tableData = res.data.items
            table.totalCount = res.data.totalCount
          }
        }
      )
    }
  }

  orderTypeString(type) {
    let text = type
    switch (type) {
      case 0:
        text = '常规订单'
        break
      case 1:
        text = '拼团订单'
        break
      case 2:
        text = '积分订单'
        break
    }

    return text
  }

  /**
   * 查看订单详情
   */
  orderDetailFn(row) {
    this.$router.push({
      name: 'orderDetail',
      query: {
        id: row.id,
      },
    })
  }

  /**
   * 发货
   */
  shipmentFN(row) {
    this.$router.push({
      name: 'deliverGood',
      query: {
        id: row.id,
      },
    })
  }

  /**
   * 取消待付款订单
   */
  cancelOrder(row) {
    this.$Modal.confirm({
      title: '提示',
      content: '确认取消此订单？',
      onOk: () => {
        let list: any = [row.id]
        OrderApi.cancelOrder(list)
          .then((res) => {
            this.$Notice.success({ desc: '取消成功' })
            this.getOrderList()
          })
          .catch((err) => { })
      },
    })
  }

  /**
   * 获取会员积分记录
   */
  getBonusLog() {
    let id = this.$route.query['id']
    if (id) {
      VipApi.getBonusLog(id.toString(), this.table2.pageSize, this.table2.currentPage).then((res) => {
        this.tableData2 = res.data.items
        this.table2.totalCount = res.data.totalCount
      })
    }
  }

  /**
   * 获取会员储值记录
   */
  getBalanceLogs() {
    let id = this.$route.query['id']
    if (id) {
      VipApi.getBalanceLogs(id.toString(), this.table3.pageSize, this.table3.currentPage).then((res) => {
        this.tableData3 = res.data.items
        this.table3.totalCount = res.data.totalCount
      })
    }
  }

  /**
   * 获取指定会员的收藏
   */
  getVipFavorite() {
    let id = this.$route.query['id']
    if (id) {
      VipApi.getVipFavorite(id.toString(), this.table4.pageSize, this.table4.currentPage).then((res) => {
        this.tableData4 = res.data.items
        this.table4.totalCount = res.data.totalCount
      })
    }
  }

  /**
   * 获取会员浏览记录
   */
  getVipRecentLogs() {
    let id = this.$route.query['id']
    if (id) {
      VipApi.getVipRecentLogs(id.toString(), this.table5.pageSize, this.table5.currentPage, this.recentType).then(
        (res) => {
          this.tableData5 = res.data.items
          this.table5.totalCount = res.data.totalCount
        }
      )
    }
  }
   // 获取会员的优惠券
   getVipCoupons() {
    let id = this.$route.query['id']
    if (id) {
      VipApi.getVipCoupons(id.toString(), this.table6.pageSize, this.table6.currentPage).then(
        (res) => {
          this.tableData6 = res.data.items
          this.table6.totalCount = res.data.totalCount
        }
      )
    }
  }
  /**
   * 浏览类型转文本
   */
  recentTypeString(type) {
    let text = type
    this.recentTypeList.forEach((item) => {
      if (type == item.value) {
        text = item.title
      }
    })
    return text
  }

  /**
   * 更改页数
   */
  changePage(e, which, click?) {
    switch (which) {
      case 1:
        this.table.currentPage = e
        break
      default:
        this['table' + which].currentPage = e
        break
    }
    if (this[click]) {
      this[click]()
    }
  }
  updateRemark() {
    let self = this
    let value = this.vipInfos.remark
    this.$Modal.confirm({
      render: (h) => {
        return h('Input', {
          props: {
            value: value,
            autofocus: true,
            placeholder: '请输入备注名称...',
          },
          on: {
            input: (val) => {
              value = val
            },
          },
        })
      },
      onOk: () => {
        self.vipInfos.remark = value
        VipApi.updateRemark(self.vipInfos.id, self.vipInfos.remark).then((res) => {
          self.$Message.success('保存成功')
        })
      },
    })
  }
  handleClose(index) {
    let copySelectItems = JSON.parse(JSON.stringify(this.tagList))
    copySelectItems.splice(index, 1)
    let arr = this.allTagList.filter((item) => copySelectItems.indexOf(item.name) > -1)
    let tagIds = arr.map((item) => item.value)
    VipTag.VipTagUser(tagIds, [(this.$route.query as any).id]).then((res) => {
      this.getVipInfos()
    })
  }
  handleAdd() {
    this.showTag = !this.showTag
    this.selectedItems = this.vipInfos.tags
  }
  getTagList() {
    VipTag.getAllTagList(false).then((res) => {
      this.allTagList = res.data.items
    })
  }
  tagChange(e) {
    VipTag.VipTagUser(e, [(this.$route.query as any).id]).then((res) => {
      this.getVipInfos()
    })
  }
}
